import { Search, MessageCircle, ShieldCheck } from "lucide-react";

const steps = [
  {
    icon: Search,
    title: "Whisper a Dream",
    body: "Type any destination.",
  },
  {
    icon: MessageCircle,
    title: "Chat with Concierge",
    body: "Our expert asks the right questions — nothing feels generic.",
  },
  {
    icon: ShieldCheck,
    title: "Verify & Receive",
    body: "OTP verify — we draft a 3-day plan, sent on WhatsApp.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      className="bg-[var(--vp-bg)] py-16 md:py-20 px-6 md:px-12"
      data-testid="how-it-works-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="vp-label block mb-2">THE PROCESS</span>
          <h2 className="text-2xl md:text-3xl font-semibold text-[var(--vp-primary)] tracking-tight">
            Three unhurried steps<span className="text-[var(--vp-secondary)]"> · </span>
            daydream to departure
          </h2>
        </div>

        {/* Horizontal pipeline with continuous connecting line — stays in a row on ALL screens */}
        <div className="relative">
          {/* Connecting line behind the step circles */}
          <div
            className="absolute top-6 left-[16%] right-[16%] h-[2px] bg-gradient-to-r from-[var(--vp-secondary)] via-[var(--vp-accent)] to-[var(--vp-secondary)] opacity-40"
            aria-hidden
          />
          <div className="relative grid grid-cols-3 gap-2 sm:gap-4">
            {steps.map((s, i) => (
              <div
                key={s.title}
                className="flex flex-col items-center text-center relative"
                data-testid={`step-${i + 1}`}
              >
                {/* Numbered circle on the line */}
                <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-white border-2 border-[var(--vp-secondary)] flex items-center justify-center shadow-md mb-3 sm:mb-5 relative z-10">
                  <s.icon className="w-5 h-5 sm:w-6 sm:h-6 text-[var(--vp-secondary)]" strokeWidth={1.75} />
                </div>
                <div className="text-[10px] sm:text-xs tracking-[0.22em] uppercase font-semibold text-[var(--vp-accent)] mb-1 sm:mb-2">
                  Step 0{i + 1}
                </div>
                <h3 className="text-sm sm:text-lg font-semibold text-[var(--vp-primary)] mb-1 px-1">
                  {s.title}
                </h3>
                <p className="hidden sm:block text-sm text-[var(--vp-muted)] max-w-[220px]">
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
